// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Config$SmartcutsMacros = require("../../Config.bs.js");
var Selector$SmartcutsMacros = require("../../Selector.bs.js");
var ExtErrors$SmartcutsMacros = require("../../ExtErrors.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../../../bs-utils/src/DeccoUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../../bs-utils/src/StringUtils.bs.js");
var StateMachine$SmartcutsMacros = require("../../StateMachine.bs.js");
var Browser__Tabs$SmartcutsMacros = require("../../browser/Browser__Tabs.bs.js");
var Browser__Runtime$SmartcutsMacros = require("../../browser/Browser__Runtime.bs.js");
var Browser__Windows$SmartcutsMacros = require("../../browser/Browser__Windows.bs.js");
var SelectorOverrides$SmartcutsMacros = require("../../commands/shared/SelectorOverrides.bs.js");
var ExtensionMessaging$SmartcutsMacros = require("../../ExtensionMessaging.bs.js");
var SelectionSemantics$SmartcutsMacros = require("../../SelectionSemantics/SelectionSemantics.bs.js");
var GenericCommandStack$SmartcutsMacros = require("../../GenericCommandStack.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var PermissionAndOrigin$SmartcutsMacros = require("../../PermissionAndOrigin.bs.js");
var Browser__WebNavigation$SmartcutsMacros = require("../../browser/Browser__WebNavigation.bs.js");
var ExtErrors__OverlayBlocking$SmartcutsMacros = require("../../ExtErrors__OverlayBlocking.bs.js");
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = require("../../InterfaceBtwnContentScriptAndBg.bs.js");
var ExtensionMessaging__FromExtension$SmartcutsMacros = require("../../ExtensionMessaging__FromExtension.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("../../InterfaceBtwnRecordingAndPlayback.bs.js");
var ContentScript__StateMachine__Types$SmartcutsMacros = require("../../ContentScript/StateMachine/ContentScript__StateMachine__Types.bs.js");
var ExtensionMessagingAndStateMachineTypes$SmartcutsMacros = require("../../ExtensionMessagingAndStateMachineTypes.bs.js");

function basicEvent_encode(v) {
  if (typeof v === "number") {
    if (v === /* DidNotGetOAuthToken */0) {
      return ["DidNotGetOAuthToken"];
    } else {
      return ["DidEncounterGoogleSheetAuthenticationError"];
    }
  }
  switch (v.TAG | 0) {
    case /* MessageToExtension */0 :
        return [
                "MessageToExtension",
                Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.message_encode, v._0),
                Browser__Runtime$SmartcutsMacros.Sender.t_encode(v._1),
                Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.respondToSender_encode, v._2),
                ExtensionMessaging$SmartcutsMacros.rejectToTab_encode(v._3)
              ];
    case /* BrowserActionClicked */1 :
        return [
                "BrowserActionClicked",
                Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._0)
              ];
    case /* GotWindowInfo */2 :
        return [
                "GotWindowInfo",
                Decco.intToJson(v._0),
                Curry._1(Browser__Windows$SmartcutsMacros.$$Window.t_encode, v._1),
                Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._2)
              ];
    case /* GotTabInfo */3 :
        return [
                "GotTabInfo",
                Decco.intToJson(v._0),
                Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._1)
              ];
    case /* OnWebNavigationBeforeNavigate */4 :
        return [
                "OnWebNavigationBeforeNavigate",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnBeforeNavigate.Details.t_encode, v._0)
              ];
    case /* OnWebNavigationCommitted */5 :
        return [
                "OnWebNavigationCommitted",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.record_encode, v._0)
              ];
    case /* OnWebNavigationHistoryStateUpdated */6 :
        return [
                "OnWebNavigationHistoryStateUpdated",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.record_encode, v._0)
              ];
    case /* OnWebNavigationCompleted */7 :
        return [
                "OnWebNavigationCompleted",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCompleted.Details.t_encode, v._0)
              ];
    case /* OnMainFrameWebNavigationError */8 :
        return [
                "OnMainFrameWebNavigationError",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_encode, v._0)
              ];
    case /* OnSubFrameWebNavigationError */9 :
        return [
                "OnSubFrameWebNavigationError",
                Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_encode, v._0)
              ];
    case /* OnReceivingEndDoesNotExistForTab */10 :
        return [
                "OnReceivingEndDoesNotExistForTab",
                Decco.intToJson(v._0)
              ];
    case /* OnTabCreated */11 :
        return [
                "OnTabCreated",
                Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._0)
              ];
    case /* OnTabUpdated */12 :
        return [
                "OnTabUpdated",
                Decco.intToJson(v._0),
                Curry._1(Browser__Tabs$SmartcutsMacros.OnUpdated.ChangeInfo.Record.t_encode, v._1),
                Browser__Tabs$SmartcutsMacros.Tab.t_encode(v._2)
              ];
    case /* OnTabRemoved */13 :
        return [
                "OnTabRemoved",
                Decco.intToJson(v._0),
                Curry._1(Browser__Tabs$SmartcutsMacros.OnRemoved.RemoveInfo.t_encode, v._1)
              ];
    case /* OnTabMovedWithinWindow */14 :
        return [
                "OnTabMovedWithinWindow",
                Decco.intToJson(v._0),
                Curry._1(Browser__Tabs$SmartcutsMacros.OnMoved.MoveInfo.t_encode, v._1)
              ];
    case /* OnTabDetached */15 :
        return [
                "OnTabDetached",
                Decco.intToJson(v._0),
                Curry._1(Browser__Tabs$SmartcutsMacros.OnDetached.DetachInfo.t_encode, v._1)
              ];
    case /* OnTabAttached */16 :
        return [
                "OnTabAttached",
                Decco.intToJson(v._0),
                Curry._1(Browser__Tabs$SmartcutsMacros.OnAttached.AttachInfo.t_encode, v._1)
              ];
    case /* OnActiveTab */17 :
        return [
                "OnActiveTab",
                Curry._1(Browser__Tabs$SmartcutsMacros.OnActivated.ActiveInfo.t_encode, v._0)
              ];
    case /* OnReplacedTab */18 :
        return [
                "OnReplacedTab",
                Decco.intToJson(v._0),
                Decco.intToJson(v._1)
              ];
    case /* OnWindowCreated */19 :
        return [
                "OnWindowCreated",
                Curry._1(Browser__Windows$SmartcutsMacros.$$Window.t_encode, v._0)
              ];
    case /* OnWindowRemoved */20 :
        return [
                "OnWindowRemoved",
                Decco.intToJson(v._0)
              ];
    case /* OnWindowFocusChange */21 :
        return [
                "OnWindowFocusChange",
                Decco.intToJson(v._0)
              ];
    case /* OnNotificationButtonClicked */22 :
        return [
                "OnNotificationButtonClicked",
                Decco.stringToJson(v._0),
                Decco.intToJson(v._1)
              ];
    case /* DidGetOAuthToken */23 :
        return [
                "DidGetOAuthToken",
                Decco.stringToJson(v._0),
                Decco.boolToJson(v._1)
              ];
    case /* DidRemoveCachedOAuthToken */24 :
        return [
                "DidRemoveCachedOAuthToken",
                Decco.stringToJson(v._0)
              ];
    case /* DidNotRemoveCachedOAuthToken */25 :
        return [
                "DidNotRemoveCachedOAuthToken",
                Decco.stringToJson(v._0)
              ];
    
  }
}

function basicEvent_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BrowserActionClicked" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BrowserActionClicked */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidEncounterGoogleSheetAuthenticationError" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidEncounterGoogleSheetAuthenticationError */1
                  };
          }
      case "DidGetOAuthToken" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.boolFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* DidGetOAuthToken */23,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "DidNotGetOAuthToken" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotGetOAuthToken */0
                  };
          }
      case "DidNotRemoveCachedOAuthToken" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidNotRemoveCachedOAuthToken */25,
                      _0: v0$1._0
                    }
                  };
          }
          var e$3 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "DidRemoveCachedOAuthToken" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidRemoveCachedOAuthToken */24,
                      _0: v0$2._0
                    }
                  };
          }
          var e$4 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "GotTabInfo" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* GotTabInfo */3,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$5 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "GotWindowInfo" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = Curry._1(Browser__Windows$SmartcutsMacros.$$Window.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          var match$7 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              if (match$7.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* GotWindowInfo */2,
                          _0: match$5._0,
                          _1: match$6._0,
                          _2: match$7._0
                        }
                      };
              }
              var e$7 = match$7._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                      }
                    };
            }
            var e$8 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "MessageToExtension" :
          if (tagged.length !== 5) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$8 = Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.message_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$9 = Browser__Runtime$SmartcutsMacros.Sender.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$10 = Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ExtensionMessagingFromTabAll.respondToSender_decode, Belt_Array.getExn(jsonArr$1, 3));
          var match$11 = ExtensionMessaging$SmartcutsMacros.rejectToTab_decode(Belt_Array.getExn(jsonArr$1, 4));
          if (match$8.TAG === /* Ok */0) {
            if (match$9.TAG === /* Ok */0) {
              if (match$10.TAG === /* Ok */0) {
                if (match$11.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            TAG: /* MessageToExtension */0,
                            _0: match$8._0,
                            _1: match$9._0,
                            _2: match$10._0,
                            _3: match$11._0
                          }
                        };
                }
                var e$10 = match$11._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[3]" + e$10.path,
                          message: e$10.message,
                          value: e$10.value
                        }
                      };
              }
              var e$11 = match$10._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                      }
                    };
            }
            var e$12 = match$9._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$12.path,
                      message: e$12.message,
                      value: e$12.value
                    }
                  };
          }
          var e$13 = match$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "OnActiveTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Curry._1(Browser__Tabs$SmartcutsMacros.OnActivated.ActiveInfo.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnActiveTab */17,
                      _0: v0$3._0
                    }
                  };
          }
          var e$14 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "OnMainFrameWebNavigationError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnMainFrameWebNavigationError */8,
                      _0: v0$4._0
                    }
                  };
          }
          var e$15 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "OnNotificationButtonClicked" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$12 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$13 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$12.TAG === /* Ok */0) {
            if (match$13.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* OnNotificationButtonClicked */22,
                        _0: match$12._0,
                        _1: match$13._0
                      }
                    };
            }
            var e$16 = match$13._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$16.path,
                      message: e$16.message,
                      value: e$16.value
                    }
                  };
          }
          var e$17 = match$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "OnReceivingEndDoesNotExistForTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnReceivingEndDoesNotExistForTab */10,
                      _0: v0$5._0
                    }
                  };
          }
          var e$18 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "OnReplacedTab" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$14 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$15 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$14.TAG === /* Ok */0) {
            if (match$15.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* OnReplacedTab */18,
                        _0: match$14._0,
                        _1: match$15._0
                      }
                    };
            }
            var e$19 = match$15._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$19.path,
                      message: e$19.message,
                      value: e$19.value
                    }
                  };
          }
          var e$20 = match$14._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      case "OnSubFrameWebNavigationError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnSubFrameWebNavigationError */9,
                      _0: v0$6._0
                    }
                  };
          }
          var e$21 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$21.path,
                    message: e$21.message,
                    value: e$21.value
                  }
                };
      case "OnTabAttached" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$16 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$17 = Curry._1(Browser__Tabs$SmartcutsMacros.OnAttached.AttachInfo.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$16.TAG === /* Ok */0) {
            if (match$17.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* OnTabAttached */16,
                        _0: match$16._0,
                        _1: match$17._0
                      }
                    };
            }
            var e$22 = match$17._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$22.path,
                      message: e$22.message,
                      value: e$22.value
                    }
                  };
          }
          var e$23 = match$16._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                  }
                };
      case "OnTabCreated" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnTabCreated */11,
                      _0: v0$7._0
                    }
                  };
          }
          var e$24 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                  }
                };
      case "OnTabDetached" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$18 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$19 = Curry._1(Browser__Tabs$SmartcutsMacros.OnDetached.DetachInfo.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$18.TAG === /* Ok */0) {
            if (match$19.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* OnTabDetached */15,
                        _0: match$18._0,
                        _1: match$19._0
                      }
                    };
            }
            var e$25 = match$19._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$25.path,
                      message: e$25.message,
                      value: e$25.value
                    }
                  };
          }
          var e$26 = match$18._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$26.path,
                    message: e$26.message,
                    value: e$26.value
                  }
                };
      case "OnTabMovedWithinWindow" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$20 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$21 = Curry._1(Browser__Tabs$SmartcutsMacros.OnMoved.MoveInfo.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$20.TAG === /* Ok */0) {
            if (match$21.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* OnTabMovedWithinWindow */14,
                        _0: match$20._0,
                        _1: match$21._0
                      }
                    };
            }
            var e$27 = match$21._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$27.path,
                      message: e$27.message,
                      value: e$27.value
                    }
                  };
          }
          var e$28 = match$20._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$28.path,
                    message: e$28.message,
                    value: e$28.value
                  }
                };
      case "OnTabRemoved" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$22 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$23 = Curry._1(Browser__Tabs$SmartcutsMacros.OnRemoved.RemoveInfo.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$22.TAG === /* Ok */0) {
            if (match$23.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* OnTabRemoved */13,
                        _0: match$22._0,
                        _1: match$23._0
                      }
                    };
            }
            var e$29 = match$23._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$29.path,
                      message: e$29.message,
                      value: e$29.value
                    }
                  };
          }
          var e$30 = match$22._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$30.path,
                    message: e$30.message,
                    value: e$30.value
                  }
                };
      case "OnTabUpdated" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$24 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$25 = Curry._1(Browser__Tabs$SmartcutsMacros.OnUpdated.ChangeInfo.Record.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          var match$26 = Browser__Tabs$SmartcutsMacros.Tab.t_decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$24.TAG === /* Ok */0) {
            if (match$25.TAG === /* Ok */0) {
              if (match$26.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* OnTabUpdated */12,
                          _0: match$24._0,
                          _1: match$25._0,
                          _2: match$26._0
                        }
                      };
              }
              var e$31 = match$26._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$31.path,
                        message: e$31.message,
                        value: e$31.value
                      }
                    };
            }
            var e$32 = match$25._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$32.path,
                      message: e$32.message,
                      value: e$32.value
                    }
                  };
          }
          var e$33 = match$24._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$33.path,
                    message: e$33.message,
                    value: e$33.value
                  }
                };
      case "OnWebNavigationBeforeNavigate" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnBeforeNavigate.Details.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnWebNavigationBeforeNavigate */4,
                      _0: v0$8._0
                    }
                  };
          }
          var e$34 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$34.path,
                    message: e$34.message,
                    value: e$34.value
                  }
                };
      case "OnWebNavigationCommitted" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.record_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnWebNavigationCommitted */5,
                      _0: v0$9._0
                    }
                  };
          }
          var e$35 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$35.path,
                    message: e$35.message,
                    value: e$35.value
                  }
                };
      case "OnWebNavigationCompleted" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCompleted.Details.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnWebNavigationCompleted */7,
                      _0: v0$10._0
                    }
                  };
          }
          var e$36 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$36.path,
                    message: e$36.message,
                    value: e$36.value
                  }
                };
      case "OnWebNavigationHistoryStateUpdated" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$11 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.record_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$11.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnWebNavigationHistoryStateUpdated */6,
                      _0: v0$11._0
                    }
                  };
          }
          var e$37 = v0$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$37.path,
                    message: e$37.message,
                    value: e$37.value
                  }
                };
      case "OnWindowCreated" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$12 = Curry._1(Browser__Windows$SmartcutsMacros.$$Window.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$12.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnWindowCreated */19,
                      _0: v0$12._0
                    }
                  };
          }
          var e$38 = v0$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$38.path,
                    message: e$38.message,
                    value: e$38.value
                  }
                };
      case "OnWindowFocusChange" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$13 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$13.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnWindowFocusChange */21,
                      _0: v0$13._0
                    }
                  };
          }
          var e$39 = v0$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$39.path,
                    message: e$39.message,
                    value: e$39.value
                  }
                };
      case "OnWindowRemoved" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$14 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$14.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OnWindowRemoved */20,
                      _0: v0$14._0
                    }
                  };
          }
          var e$40 = v0$14._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$40.path,
                    message: e$40.message,
                    value: e$40.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyBasicEvent($$event) {
  if (typeof $$event === "number") {
    if ($$event === /* DidNotGetOAuthToken */0) {
      return "DidNotGetOAuthToken";
    } else {
      return "DidEncounterGoogleSheetAuthenticationError";
    }
  }
  switch ($$event.TAG | 0) {
    case /* MessageToExtension */0 :
        return "MessageToExtension(, message=" + (Curry._1(ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ExtensionMessagingLogging.FromTab.AllAll.stringifyMessage, $$event._0) + (", " + (Browser__Runtime$SmartcutsMacros.Sender.stringify($$event._1) + ", respondToTab, rejectToTab)")));
    case /* BrowserActionClicked */1 :
        return "BrowserActionClicked(tab)";
    case /* GotWindowInfo */2 :
        return "GotWindowInfo(windowId, window, activeTab)";
    case /* GotTabInfo */3 :
        return "GotTabInfo(tabId=" + (String($$event._0) + ", tab)");
    case /* OnWebNavigationBeforeNavigate */4 :
        return "OnWebNavigationBeforeNavigate(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnBeforeNavigate.Details.stringify, $$event._0) + ")");
    case /* OnWebNavigationCommitted */5 :
        return "OnWebNavigationCommitted(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.stringify, $$event._0) + ")");
    case /* OnWebNavigationHistoryStateUpdated */6 :
        return "OnWebNavigationHistoryStateUpdated(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnCommitted.Details.stringify, $$event._0) + ")");
    case /* OnWebNavigationCompleted */7 :
        var details = $$event._0;
        return "OnWebNavigationCompleted(details={tabId=" + (String(details.tabId) + (", url=" + (details.url + ", ...})")));
    case /* OnMainFrameWebNavigationError */8 :
        return "OnMainFrameWebNavigationError(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.stringify, $$event._0) + ")");
    case /* OnSubFrameWebNavigationError */9 :
        return "OnSubFrameWebNavigationError(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.stringify, $$event._0) + ")");
    case /* OnReceivingEndDoesNotExistForTab */10 :
        return "OnReceivingEndDoesNotExistForTab(" + (String($$event._0) + ")");
    case /* OnTabCreated */11 :
        var tab = $$event._0;
        var arg = Belt_Option.map(tab.openerTabId, (function (prim) {
                return String(prim);
              }));
        var arg$1 = Belt_Option.map(tab.pendingUrl, StringUtils$SmartcutsMacros.quote);
        var arg$2 = Belt_Option.map(tab.url, StringUtils$SmartcutsMacros.quote);
        return "OnTabCreated({id: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", Belt_Option.map(tab.id, (function (prim) {
                            return String(prim);
                          }))) + (", openerTabId: " + ((function (param) {
                          return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                        })("undefined") + (", pendingUrl: " + ((function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                            })("undefined") + (", url: " + ((function (param) {
                                  return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
                                })("undefined") + (", windowId: " + (String(tab.windowId) + "})")))))))));
    case /* OnTabUpdated */12 :
        return "OnTabUpdated(tabId=" + (String($$event._0) + (", changeInfo=" + (Curry._1(Browser__Tabs$SmartcutsMacros.OnUpdated.ChangeInfo.stringify, $$event._1) + ", tab)")));
    case /* OnTabRemoved */13 :
        return "OnTabRemoved(tabId=" + (String($$event._0) + ", removeInfo)");
    case /* OnTabMovedWithinWindow */14 :
        return "OnTabMovedWithinWindow(tabId=" + (String($$event._0) + ", moveInfo)");
    case /* OnTabDetached */15 :
        return "OnTabDetached(tabId=" + (String($$event._0) + ", detachInfo)");
    case /* OnTabAttached */16 :
        return "OnTabAttached(tabId=" + (String($$event._0) + ", attachInfo)");
    case /* OnActiveTab */17 :
        var activeInfo = $$event._0;
        return "OnActiveTab({tabId=" + (String(activeInfo.tabId) + (", windowId=" + (String(activeInfo.windowId) + "})")));
    case /* OnReplacedTab */18 :
        return "OnReplacedTab(addedTabId=" + (String($$event._0) + (", removedTabId=" + (String($$event._1) + ")")));
    case /* OnWindowCreated */19 :
        return "OnWindowCreated(window)";
    case /* OnWindowRemoved */20 :
        return "OnWindowRemoved(windowId=" + (String($$event._0) + ")");
    case /* OnWindowFocusChange */21 :
        return "OnWindowFocusChange(windowId=" + (String($$event._0) + ")");
    case /* OnNotificationButtonClicked */22 :
        return "OnNotificationButtonClicked(" + ($$event._0 + (", indexOfButtonClicked=" + (String($$event._1) + ")")));
    case /* DidGetOAuthToken */23 :
        return "DidGetOAuthToken(_token, " + (Pervasives.string_of_bool($$event._1) + ")");
    case /* DidRemoveCachedOAuthToken */24 :
        return "DidRemoveCachedOAuthToken(" + ($$event._0 + ")");
    case /* DidNotRemoveCachedOAuthToken */25 :
        return "DidNotRemoveCachedOAuthToken(<token>)";
    
  }
}

function extractRespondToTabFromBasicEvent($$event) {
  if (typeof $$event === "number" || $$event.TAG !== /* MessageToExtension */0) {
    return ;
  } else {
    return $$event._2;
  }
}

function extractTabIdsFromBasicEvent($$event) {
  var tmp;
  var exit = 0;
  if (typeof $$event === "number") {
    tmp = /* [] */0;
  } else {
    switch ($$event.TAG | 0) {
      case /* MessageToExtension */0 :
          tmp = OptionUtils$SmartcutsMacros.withDefault(/* [] */0, OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.andThen((function (tab) {
                          return tab.id;
                        }), $$event._1.tab), (function (tabId) {
                      return {
                              hd: tabId,
                              tl: /* [] */0
                            };
                    })));
          break;
      case /* OnMainFrameWebNavigationError */8 :
      case /* OnSubFrameWebNavigationError */9 :
          tmp = {
            hd: $$event._0.tabId,
            tl: /* [] */0
          };
          break;
      case /* BrowserActionClicked */1 :
      case /* OnTabCreated */11 :
          exit = 1;
          break;
      case /* GotTabInfo */3 :
      case /* OnReceivingEndDoesNotExistForTab */10 :
      case /* OnTabUpdated */12 :
      case /* OnTabRemoved */13 :
      case /* OnTabMovedWithinWindow */14 :
      case /* OnTabDetached */15 :
      case /* OnTabAttached */16 :
          tmp = {
            hd: $$event._0,
            tl: /* [] */0
          };
          break;
      case /* OnWebNavigationBeforeNavigate */4 :
      case /* OnWebNavigationCommitted */5 :
      case /* OnWebNavigationHistoryStateUpdated */6 :
      case /* OnWebNavigationCompleted */7 :
      case /* OnActiveTab */17 :
          exit = 2;
          break;
      case /* OnReplacedTab */18 :
          tmp = {
            hd: $$event._0,
            tl: {
              hd: $$event._1,
              tl: /* [] */0
            }
          };
          break;
      case /* OnWindowCreated */19 :
          tmp = Browser__Windows$SmartcutsMacros.$$Window.extractTabIds($$event._0);
          break;
      case /* GotWindowInfo */2 :
      case /* OnWindowRemoved */20 :
      case /* OnWindowFocusChange */21 :
          tmp = /* [] */0;
          break;
      default:
        tmp = /* [] */0;
    }
  }
  switch (exit) {
    case 1 :
        var tabId = $$event._0.id;
        tmp = tabId !== undefined ? ({
              hd: tabId,
              tl: /* [] */0
            }) : /* [] */0;
        break;
    case 2 :
        tmp = {
          hd: $$event._0.tabId,
          tl: /* [] */0
        };
        break;
    
  }
  return List.map(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.makePlaybackId, tmp);
}

function failWithReceivedExtensionMessagingResponse_encode(v) {
  return Js_dict.fromArray([
              [
                "failureId",
                InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v.failureId)
              ],
              [
                "failure",
                Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.otherFailureReason_encode, v.failure)
              ],
              [
                "errorContext",
                Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.errorContext_encode, v.errorContext)
              ],
              [
                "history",
                StateMachine$SmartcutsMacros.$$History.t_encode(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.listener_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, v.history)
              ]
            ]);
}

function failWithReceivedExtensionMessagingResponse_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var failureId = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failureId"), null));
  if (failureId.TAG === /* Ok */0) {
    var failure = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.otherFailureReason_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failure"), null));
    if (failure.TAG === /* Ok */0) {
      var errorContext = Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.errorContext_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "errorContext"), null));
      if (errorContext.TAG === /* Ok */0) {
        var history = StateMachine$SmartcutsMacros.$$History.t_decode(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.listener_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "history"), null));
        if (history.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    failureId: failureId._0,
                    failure: failure._0,
                    errorContext: errorContext._0,
                    history: history._0
                  }
                };
        }
        var e = history._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".history" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = errorContext._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".errorContext" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = failure._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".failure" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = failureId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".failureId" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function failWithReceivedExtensionMessagingResponseFailureId_encode(v) {
  return Js_dict.fromArray([
              [
                "failureId",
                InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v.failureId)
              ],
              [
                "tabId",
                Decco.intToJson(v.tabId)
              ],
              [
                "messageRespondingTo",
                ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_encode(v.messageRespondingTo)
              ]
            ]);
}

function failWithReceivedExtensionMessagingResponseFailureId_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var failureId = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failureId"), null));
  if (failureId.TAG === /* Ok */0) {
    var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
    if (tabId.TAG === /* Ok */0) {
      var messageRespondingTo = ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "messageRespondingTo"), null));
      if (messageRespondingTo.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  failureId: failureId._0,
                  tabId: tabId._0,
                  messageRespondingTo: messageRespondingTo._0
                }
              };
      }
      var e = messageRespondingTo._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".messageRespondingTo" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = tabId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".tabId" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = failureId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".failureId" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function domElementRepresentation_encode(v) {
  if (v.TAG === /* NodeId */0) {
    return [
            "NodeId",
            Decco.intToJson(v._0)
          ];
  } else {
    return [
            "XPath",
            Decco.stringToJson(v._0)
          ];
  }
}

function domElementRepresentation_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NodeId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NodeId */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "XPath" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* XPath */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function elementSearchVia_encode(v) {
  switch (v.TAG | 0) {
    case /* SearchViaSelector */0 :
        return [
                "SearchViaSelector",
                Selector$SmartcutsMacros.selector_encode(v._0)
              ];
    case /* SearchViaElementLocator */1 :
        return [
                "SearchViaElementLocator",
                SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_encode(v._0)
              ];
    case /* SearchViaCssSelector */2 :
        return [
                "SearchViaCssSelector",
                Decco.stringToJson(v._0)
              ];
    
  }
}

function elementSearchVia_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "SearchViaCssSelector" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SearchViaCssSelector */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SearchViaElementLocator" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SearchViaElementLocator */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "SearchViaSelector" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SearchViaSelector */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function otherFailureReasonShared_encode(v) {
  if (typeof v === "number") {
    switch (v) {
      case /* FailWithReceivingEndDoesNotExist */0 :
          return ["FailWithReceivingEndDoesNotExist"];
      case /* FailWithNoActiveTabToReceiveMessage */1 :
          return ["FailWithNoActiveTabToReceiveMessage"];
      case /* FailWithUserCancellation */2 :
          return ["FailWithUserCancellation"];
      case /* FailWithUserStopPlayback */3 :
          return ["FailWithUserStopPlayback"];
      case /* FailWithPlaybackDownloadNeverInitiated */4 :
          return ["FailWithPlaybackDownloadNeverInitiated"];
      case /* FailWithOAuthTokenNotGranted */5 :
          return ["FailWithOAuthTokenNotGranted"];
      case /* FailWithUnhandledException */6 :
          return ["FailWithUnhandledException"];
      case /* FailWithNoAvailableExecutions */7 :
          return ["FailWithNoAvailableExecutions"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* FailWithWebNavError */0 :
          return [
                  "FailWithWebNavError",
                  Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_encode, v._0)
                ];
      case /* FailWithContentScriptFailure */1 :
          return [
                  "FailWithContentScriptFailure",
                  Decco.intToJson(v._0),
                  Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.otherFailureReason_encode, v._1),
                  Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.errorContext_encode, v._2),
                  StateMachine$SmartcutsMacros.$$History.t_encode(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.listener_encode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, v._3)
                ];
      case /* FailWithReceivedExtensionMessagingResponse */2 :
          return [
                  "FailWithReceivedExtensionMessagingResponse",
                  failWithReceivedExtensionMessagingResponse_encode(v._0)
                ];
      case /* FailWithReceivedExtensionMessagingResponseFailureId */3 :
          return [
                  "FailWithReceivedExtensionMessagingResponseFailureId",
                  failWithReceivedExtensionMessagingResponseFailureId_encode(v._0)
                ];
      case /* FailWithUserCloseLoginPage */4 :
          return [
                  "FailWithUserCloseLoginPage",
                  Decco.stringToJson(v._0)
                ];
      case /* FailWithElementNotFound */5 :
          return [
                  "FailWithElementNotFound",
                  Decco.stringToJson(v._0),
                  elementSearchVia_encode(v._1)
                ];
      case /* FailWithCannotCopyMissingSrcOfImg */6 :
          return [
                  "FailWithCannotCopyMissingSrcOfImg",
                  Decco.stringToJson(v._0),
                  elementSearchVia_encode(v._1)
                ];
      case /* FailWithDocumentNotVisible */7 :
          return [
                  "FailWithDocumentNotVisible",
                  Decco.stringToJson(v._0)
                ];
      case /* FailWithDocumentVisibilityUnknownOrUnloaded */8 :
          return [
                  "FailWithDocumentVisibilityUnknownOrUnloaded",
                  Decco.stringToJson(v._0)
                ];
      case /* FailWithCdpUnableToGetDocument */9 :
          return [
                  "FailWithCdpUnableToGetDocument",
                  Decco.stringToJson(v._0)
                ];
      case /* FailWithCdpUnableToGetContentQuads */10 :
          return [
                  "FailWithCdpUnableToGetContentQuads",
                  Decco.stringToJson(v._0)
                ];
      case /* FailWithCouldNotApplySemantic */11 :
          return [
                  "FailWithCouldNotApplySemantic",
                  SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_encode(v._0),
                  Decco.stringToJson(v._1)
                ];
      case /* FailWithBlockingOverlay */12 :
          return [
                  "FailWithBlockingOverlay",
                  ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_encode(domElementRepresentation_encode, v._0),
                  Decco.stringToJson(v._1)
                ];
      case /* FailWithErrorWhileWaitForOverlayToUnblock */13 :
          return [
                  "FailWithErrorWhileWaitForOverlayToUnblock",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                  Decco.stringToJson(v._1)
                ];
      case /* FailWithErrorWhileSearchForElement */14 :
          return [
                  "FailWithErrorWhileSearchForElement",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                  Decco.stringToJson(v._1)
                ];
      case /* FailWithErrorWhileSearchViaCdpQuerySelector */15 :
          return [
                  "FailWithErrorWhileSearchViaCdpQuerySelector",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                  Decco.stringToJson(v._1)
                ];
      case /* FailWithPlaybackCaptureScreenshotError */16 :
          return [
                  "FailWithPlaybackCaptureScreenshotError",
                  ExtErrors$SmartcutsMacros.PlaybackCaptureScreenshotError.t_encode(v._0),
                  Decco.stringToJson(v._1)
                ];
      case /* FailWithNoSwitchPredicateSatisfied */17 :
          return [
                  "FailWithNoSwitchPredicateSatisfied",
                  Decco.stringToJson(v._0)
                ];
      case /* FailWithPermissionsRejected */18 :
          return [
                  "FailWithPermissionsRejected",
                  Decco.arrayToJson(PermissionAndOrigin$SmartcutsMacros.t_encode, v._0)
                ];
      case /* FailWithCommandStackInitError */19 :
          return [
                  "FailWithCommandStackInitError",
                  GenericCommandStack$SmartcutsMacros.initError_encode(v._0)
                ];
      case /* FailWithCommandStackRewindError */20 :
          return [
                  "FailWithCommandStackRewindError",
                  GenericCommandStack$SmartcutsMacros.rewindError_encode(v._0)
                ];
      
    }
  }
}

function otherFailureReasonShared_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FailWithBlockingOverlay" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_decode(domElementRepresentation_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithBlockingOverlay */12,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "FailWithCannotCopyMissingSrcOfImg" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = elementSearchVia_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithCannotCopyMissingSrcOfImg */6,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "FailWithCdpUnableToGetContentQuads" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithCdpUnableToGetContentQuads */10,
                      _0: v0._0
                    }
                  };
          }
          var e$4 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "FailWithCdpUnableToGetDocument" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithCdpUnableToGetDocument */9,
                      _0: v0$1._0
                    }
                  };
          }
          var e$5 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "FailWithCommandStackInitError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = GenericCommandStack$SmartcutsMacros.initError_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithCommandStackInitError */19,
                      _0: v0$2._0
                    }
                  };
          }
          var e$6 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "FailWithCommandStackRewindError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = GenericCommandStack$SmartcutsMacros.rewindError_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithCommandStackRewindError */20,
                      _0: v0$3._0
                    }
                  };
          }
          var e$7 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "FailWithContentScriptFailure" :
          if (tagged.length !== 5) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 2));
          var match$7 = Curry._1(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.errorContext_decode, Belt_Array.getExn(jsonArr$1, 3));
          var match$8 = StateMachine$SmartcutsMacros.$$History.t_decode(ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.listener_decode, ContentScript__StateMachine__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, Belt_Array.getExn(jsonArr$1, 4));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              if (match$7.TAG === /* Ok */0) {
                if (match$8.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            TAG: /* FailWithContentScriptFailure */1,
                            _0: match$5._0,
                            _1: match$6._0,
                            _2: match$7._0,
                            _3: match$8._0
                          }
                        };
                }
                var e$8 = match$8._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[3]" + e$8.path,
                          message: e$8.message,
                          value: e$8.value
                        }
                      };
              }
              var e$9 = match$7._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                      }
                    };
            }
            var e$10 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$10.path,
                      message: e$10.message,
                      value: e$10.value
                    }
                  };
          }
          var e$11 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "FailWithCouldNotApplySemantic" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$9 = SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$10 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$9.TAG === /* Ok */0) {
            if (match$10.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithCouldNotApplySemantic */11,
                        _0: match$9._0,
                        _1: match$10._0
                      }
                    };
            }
            var e$12 = match$10._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$12.path,
                      message: e$12.message,
                      value: e$12.value
                    }
                  };
          }
          var e$13 = match$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "FailWithDocumentNotVisible" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithDocumentNotVisible */7,
                      _0: v0$4._0
                    }
                  };
          }
          var e$14 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "FailWithDocumentVisibilityUnknownOrUnloaded" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithDocumentVisibilityUnknownOrUnloaded */8,
                      _0: v0$5._0
                    }
                  };
          }
          var e$15 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "FailWithElementNotFound" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$11 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$12 = elementSearchVia_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$11.TAG === /* Ok */0) {
            if (match$12.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithElementNotFound */5,
                        _0: match$11._0,
                        _1: match$12._0
                      }
                    };
            }
            var e$16 = match$12._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$16.path,
                      message: e$16.message,
                      value: e$16.value
                    }
                  };
          }
          var e$17 = match$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "FailWithErrorWhileSearchForElement" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$13 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$14 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$13.TAG === /* Ok */0) {
            if (match$14.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithErrorWhileSearchForElement */14,
                        _0: match$13._0,
                        _1: match$14._0
                      }
                    };
            }
            var e$18 = match$14._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$18.path,
                      message: e$18.message,
                      value: e$18.value
                    }
                  };
          }
          var e$19 = match$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "FailWithErrorWhileSearchViaCdpQuerySelector" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$15 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$16 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$15.TAG === /* Ok */0) {
            if (match$16.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithErrorWhileSearchViaCdpQuerySelector */15,
                        _0: match$15._0,
                        _1: match$16._0
                      }
                    };
            }
            var e$20 = match$16._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$20.path,
                      message: e$20.message,
                      value: e$20.value
                    }
                  };
          }
          var e$21 = match$15._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$21.path,
                    message: e$21.message,
                    value: e$21.value
                  }
                };
      case "FailWithErrorWhileWaitForOverlayToUnblock" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$17 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$18 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$17.TAG === /* Ok */0) {
            if (match$18.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithErrorWhileWaitForOverlayToUnblock */13,
                        _0: match$17._0,
                        _1: match$18._0
                      }
                    };
            }
            var e$22 = match$18._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$22.path,
                      message: e$22.message,
                      value: e$22.value
                    }
                  };
          }
          var e$23 = match$17._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                  }
                };
      case "FailWithNoActiveTabToReceiveMessage" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithNoActiveTabToReceiveMessage */1
                  };
          }
      case "FailWithNoAvailableExecutions" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithNoAvailableExecutions */7
                  };
          }
      case "FailWithNoSwitchPredicateSatisfied" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithNoSwitchPredicateSatisfied */17,
                      _0: v0$6._0
                    }
                  };
          }
          var e$24 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                  }
                };
      case "FailWithOAuthTokenNotGranted" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithOAuthTokenNotGranted */5
                  };
          }
      case "FailWithPermissionsRejected" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = Decco.arrayFromJson(PermissionAndOrigin$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithPermissionsRejected */18,
                      _0: v0$7._0
                    }
                  };
          }
          var e$25 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                  }
                };
      case "FailWithPlaybackCaptureScreenshotError" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$19 = ExtErrors$SmartcutsMacros.PlaybackCaptureScreenshotError.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$20 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$19.TAG === /* Ok */0) {
            if (match$20.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* FailWithPlaybackCaptureScreenshotError */16,
                        _0: match$19._0,
                        _1: match$20._0
                      }
                    };
            }
            var e$26 = match$20._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$26.path,
                      message: e$26.message,
                      value: e$26.value
                    }
                  };
          }
          var e$27 = match$19._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$27.path,
                    message: e$27.message,
                    value: e$27.value
                  }
                };
      case "FailWithPlaybackDownloadNeverInitiated" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithPlaybackDownloadNeverInitiated */4
                  };
          }
      case "FailWithReceivedExtensionMessagingResponse" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = failWithReceivedExtensionMessagingResponse_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithReceivedExtensionMessagingResponse */2,
                      _0: v0$8._0
                    }
                  };
          }
          var e$28 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$28.path,
                    message: e$28.message,
                    value: e$28.value
                  }
                };
      case "FailWithReceivedExtensionMessagingResponseFailureId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = failWithReceivedExtensionMessagingResponseFailureId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithReceivedExtensionMessagingResponseFailureId */3,
                      _0: v0$9._0
                    }
                  };
          }
          var e$29 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$29.path,
                    message: e$29.message,
                    value: e$29.value
                  }
                };
      case "FailWithReceivingEndDoesNotExist" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithReceivingEndDoesNotExist */0
                  };
          }
      case "FailWithUnhandledException" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithUnhandledException */6
                  };
          }
      case "FailWithUserCancellation" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithUserCancellation */2
                  };
          }
      case "FailWithUserCloseLoginPage" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithUserCloseLoginPage */4,
                      _0: v0$10._0
                    }
                  };
          }
          var e$30 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$30.path,
                    message: e$30.message,
                    value: e$30.value
                  }
                };
      case "FailWithUserStopPlayback" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FailWithUserStopPlayback */3
                  };
          }
      case "FailWithWebNavError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$11 = Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$11.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FailWithWebNavError */0,
                      _0: v0$11._0
                    }
                  };
          }
          var e$31 = v0$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$31.path,
                    message: e$31.message,
                    value: e$31.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function minify(reason) {
  if (typeof reason === "number") {
    return reason;
  }
  switch (reason.TAG | 0) {
    case /* FailWithElementNotFound */5 :
    case /* FailWithCannotCopyMissingSrcOfImg */6 :
    case /* FailWithDocumentNotVisible */7 :
    case /* FailWithDocumentVisibilityUnknownOrUnloaded */8 :
    case /* FailWithCdpUnableToGetDocument */9 :
    case /* FailWithCdpUnableToGetContentQuads */10 :
    case /* FailWithCouldNotApplySemantic */11 :
    case /* FailWithBlockingOverlay */12 :
    case /* FailWithErrorWhileWaitForOverlayToUnblock */13 :
    case /* FailWithErrorWhileSearchForElement */14 :
    case /* FailWithErrorWhileSearchViaCdpQuerySelector */15 :
        return reason;
    default:
      return reason;
  }
}

function stringifyOtherFailureReason(otherFailureReason) {
  if (typeof otherFailureReason === "number") {
    switch (otherFailureReason) {
      case /* FailWithReceivingEndDoesNotExist */0 :
          return "FailWithReceivingEndDoesNotExist";
      case /* FailWithNoActiveTabToReceiveMessage */1 :
          return "FailWithNoActiveTabToReceiveMessage";
      case /* FailWithUserCancellation */2 :
          return "FailWithUserCancellation";
      case /* FailWithUserStopPlayback */3 :
          return "FailWithUserStopPlayback";
      case /* FailWithPlaybackDownloadNeverInitiated */4 :
          return "FailWithPlaybackDownloadNeverInitiated";
      case /* FailWithOAuthTokenNotGranted */5 :
          return "FailWithOAuthTokenNotGranted";
      case /* FailWithUnhandledException */6 :
          return "FailWithUnhandledException";
      case /* FailWithNoAvailableExecutions */7 :
          return "FailWithNoAvailableExecutions";
      
    }
  } else {
    switch (otherFailureReason.TAG | 0) {
      case /* FailWithWebNavError */0 :
          return "FailWithWebNavError(" + (Curry._1(Browser__WebNavigation$SmartcutsMacros.OnErrorOccurred.Details.stringify, otherFailureReason._0) + ")");
      case /* FailWithContentScriptFailure */1 :
          return "FailWithContentScriptFailure(tabId=" + (String(otherFailureReason._0) + (", failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ContentScript__StateMachine__Types__Helpers.Generic.stringifyOtherFailureReason, otherFailureReason._1) + (", errorContext=" + (Curry._1(ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ContentScript__StateMachine__Types__Helpers.ForSerialization.stringifyErrorContext, otherFailureReason._2) + (", history({len: " + (String(otherFailureReason._3.transitions.length) + "}))")))))));
      case /* FailWithReceivedExtensionMessagingResponse */2 :
          var match = otherFailureReason._0;
          return "FailWithReceivedExtensionMessagingResponse(failureId=" + (InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify(match.failureId) + (", failure=" + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ContentScript__StateMachine__Types__Helpers.Generic.stringifyOtherFailureReason, match.failure) + (", errorContext=" + (Curry._1(ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ContentScript__StateMachine__Types__Helpers.ForSerialization.stringifyErrorContext, match.errorContext) + (", history({len: " + (String(match.history.transitions.length) + "}))")))))));
      case /* FailWithReceivedExtensionMessagingResponseFailureId */3 :
          var match$1 = otherFailureReason._0;
          return "FailWithReceivedExtensionMessagingResponseFailureId(failureId=" + (InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify(match$1.failureId) + (", tabId=" + (String(match$1.tabId) + (", messageRespondingTo=" + (Curry._1(ExtensionMessagingAndStateMachineTypes$SmartcutsMacros.ExtensionMessagingLogging.FromExtension.All.stringifyMessage, match$1.messageRespondingTo) + ")")))));
      case /* FailWithUserCloseLoginPage */4 :
          return "FailWithUserCloseLoginPage(" + (otherFailureReason._0 + ")");
      case /* FailWithElementNotFound */5 :
          return "FailWithElementNotFound(" + (otherFailureReason._0 + ", elementSearchVia)");
      case /* FailWithCannotCopyMissingSrcOfImg */6 :
          return "FailWithCannotCopyMissingSrcOfImg(" + (otherFailureReason._0 + ", elementSearchVia)");
      case /* FailWithDocumentNotVisible */7 :
          return "FailWithDocumentNotVisible(" + (otherFailureReason._0 + ")");
      case /* FailWithDocumentVisibilityUnknownOrUnloaded */8 :
          return "FailWithDocumentVisibilityUnknownOrUnloaded(" + (otherFailureReason._0 + ")");
      case /* FailWithCdpUnableToGetDocument */9 :
          return "FailWithCdpUnableToGetDocument(" + (otherFailureReason._0 + ")");
      case /* FailWithCdpUnableToGetContentQuads */10 :
          return "FailWithCdpUnableToGetContentQuads(" + (otherFailureReason._0 + ")");
      case /* FailWithCouldNotApplySemantic */11 :
          return "FailWithCouldNotApplySemantic(semanticError" + (otherFailureReason._1 + ")");
      case /* FailWithBlockingOverlay */12 :
          var match$2 = otherFailureReason._0;
          var element = match$2.element;
          var tmp;
          tmp = element.TAG === /* NodeId */0 ? String(element._0) : element._0;
          var arg = Belt_Option.map(match$2.maybeOverlayElement, (function (element) {
                  if (element.TAG === /* NodeId */0) {
                    return String(element._0);
                  } else {
                    return element._0;
                  }
                }));
          return "FailWithErrorWhileWaitForOverlayToUnblock({element: " + (tmp + (", maybeOverlayElement: " + ((function (param) {
                            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                          })("None") + (", ms: " + (match$2.ms.toString() + ("}, " + (otherFailureReason._1 + ")")))))));
      case /* FailWithErrorWhileWaitForOverlayToUnblock */13 :
          return "FailWithErrorWhileWaitForOverlayToUnblock(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, otherFailureReason._0) + (", " + (otherFailureReason._1 + ")")));
      case /* FailWithErrorWhileSearchForElement */14 :
          return "FailWithErrorWhileSearchForElement(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, otherFailureReason._0) + (otherFailureReason._1 + ")"));
      case /* FailWithErrorWhileSearchViaCdpQuerySelector */15 :
          return "FailWithErrorWhileSearchViaCdpQuerySelector(" + (Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, otherFailureReason._0) + (otherFailureReason._1 + ")"));
      case /* FailWithPlaybackCaptureScreenshotError */16 :
          return "FailWithPlaybackCaptureScreenshotError(" + (ExtErrors$SmartcutsMacros.PlaybackCaptureScreenshotError.stringify(otherFailureReason._0) + (", " + (otherFailureReason._1 + ")")));
      case /* FailWithNoSwitchPredicateSatisfied */17 :
          return "FailWithNoSwitchPredicateSatisfied(" + (otherFailureReason._0 + ")");
      case /* FailWithPermissionsRejected */18 :
          return "FailWithPermissionsRejected([" + (Belt_Array.map(otherFailureReason._0, PermissionAndOrigin$SmartcutsMacros.toString).join(",") + "])");
      case /* FailWithCommandStackInitError */19 :
          return "FailWithCommandStackInitError(" + (GenericCommandStack$SmartcutsMacros.stringifyInitError(otherFailureReason._0) + ")");
      case /* FailWithCommandStackRewindError */20 :
          return "FailWithCommandStackRewindError(" + (GenericCommandStack$SmartcutsMacros.stringifyRewindError(otherFailureReason._0) + ")");
      
    }
  }
}

var detachListenersCallback_encode = DeccoUtils$SmartcutsMacros.unitToUnit_encode;

var detachListenersCallback_decode = DeccoUtils$SmartcutsMacros.unitToUnit_decode;

function listenersStatus_encode(v) {
  if (typeof v !== "number") {
    return [
            "Listening",
            DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
          ];
  }
  switch (v) {
    case /* NoListenersNeeded */0 :
        return ["NoListenersNeeded"];
    case /* BeforeAddListeners */1 :
        return ["BeforeAddListeners"];
    case /* AddingListeners */2 :
        return ["AddingListeners"];
    case /* RemovingListeners */3 :
        return ["RemovingListeners"];
    case /* RemovedAllListeners */4 :
        return ["RemovedAllListeners"];
    
  }
}

function listenersStatus_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AddingListeners" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AddingListeners */2
                  };
          }
      case "BeforeAddListeners" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BeforeAddListeners */1
                  };
          }
      case "Listening" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* Listening */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NoListenersNeeded" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoListenersNeeded */0
                  };
          }
      case "RemovedAllListeners" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RemovedAllListeners */4
                  };
          }
      case "RemovingListeners" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RemovingListeners */3
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyListenersStatus(v) {
  if (typeof v !== "number") {
    return "Listening(detachListeners)";
  }
  switch (v) {
    case /* NoListenersNeeded */0 :
        return "NoListenersNeeded";
    case /* BeforeAddListeners */1 :
        return "BeforeAddListeners";
    case /* AddingListeners */2 :
        return "AddingListeners";
    case /* RemovingListeners */3 :
        return "RemovingListeners";
    case /* RemovedAllListeners */4 :
        return "RemovedAllListeners";
    
  }
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                DeccoUtils$SmartcutsMacros.timeoutId_encode(v.id)
              ],
              [
                "timeout",
                Decco.intToJson(v.timeout)
              ],
              [
                "createdAt",
                Decco.floatToJson(v.createdAt)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var timeout = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeout"), null));
    if (timeout.TAG === /* Ok */0) {
      var createdAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "createdAt"), null));
      if (createdAt.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: id._0,
                  timeout: timeout._0,
                  createdAt: createdAt._0
                }
              };
      }
      var e = createdAt._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".createdAt" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = timeout._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".timeout" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

var StaleTimer = {
  t_encode: t_encode,
  t_decode: t_decode
};

function installedSmartcutPageUrlForUser(user, installedSmartcutId) {
  return Config$SmartcutsMacros.hostnameForUser(user) + ("/app/my_smartcuts/" + installedSmartcutId);
}

var ExtensionMessagingLogging;

exports.ExtensionMessagingLogging = ExtensionMessagingLogging;
exports.basicEvent_encode = basicEvent_encode;
exports.basicEvent_decode = basicEvent_decode;
exports.stringifyBasicEvent = stringifyBasicEvent;
exports.extractRespondToTabFromBasicEvent = extractRespondToTabFromBasicEvent;
exports.extractTabIdsFromBasicEvent = extractTabIdsFromBasicEvent;
exports.failWithReceivedExtensionMessagingResponse_encode = failWithReceivedExtensionMessagingResponse_encode;
exports.failWithReceivedExtensionMessagingResponse_decode = failWithReceivedExtensionMessagingResponse_decode;
exports.failWithReceivedExtensionMessagingResponseFailureId_encode = failWithReceivedExtensionMessagingResponseFailureId_encode;
exports.failWithReceivedExtensionMessagingResponseFailureId_decode = failWithReceivedExtensionMessagingResponseFailureId_decode;
exports.domElementRepresentation_encode = domElementRepresentation_encode;
exports.domElementRepresentation_decode = domElementRepresentation_decode;
exports.elementSearchVia_encode = elementSearchVia_encode;
exports.elementSearchVia_decode = elementSearchVia_decode;
exports.otherFailureReasonShared_encode = otherFailureReasonShared_encode;
exports.otherFailureReasonShared_decode = otherFailureReasonShared_decode;
exports.minify = minify;
exports.stringifyOtherFailureReason = stringifyOtherFailureReason;
exports.detachListenersCallback_encode = detachListenersCallback_encode;
exports.detachListenersCallback_decode = detachListenersCallback_decode;
exports.listenersStatus_encode = listenersStatus_encode;
exports.listenersStatus_decode = listenersStatus_decode;
exports.stringifyListenersStatus = stringifyListenersStatus;
exports.StaleTimer = StaleTimer;
exports.installedSmartcutPageUrlForUser = installedSmartcutPageUrlForUser;
/* Config-SmartcutsMacros Not a pure module */
